import { Box, Card, CardContent, Grid, Typography, Stack, Button } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { IDetalheProdutoEstoque } from "../../../../../../../types/api/estoque/detalhar-produto-estoque";
import { DadoValorPrinter } from "../../../../../../../components/BasicComponents/DisplayDados/DadoValorPrinter";
import { useState } from "react";
import DialogEditDadosAdicionais from "./DialogEditDadosAdicionais";

export default function CardDadosAdicionais({
    produto,
}: {
    produto: IDetalheProdutoEstoque;
}) {
    const [openEdit, setOpenEdit] = useState(false);
    return (
        <Card>
            <CardContent>
                <Box>
                    <Typography variant="h6" gutterBottom>
                        Dados Adicionais
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid size={{xs: 12, md: 4}}>
                            <DadoValorPrinter titulo="Financiamento (Código)" valor={produto.financiado ?? "-"} />
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                            <DadoValorPrinter titulo="Atual. Preço Automático" valor={produto.atualiza_preco === "S" ? "Sim" : "Não"} />
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                            <DadoValorPrinter titulo="Pr. Venda c/ 4 Decimais" valor={produto.preco_quatro_decimais === "S" ? "Sim" : "Não"} />
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                            <DadoValorPrinter titulo="% Variação Compra" valor={produto.perc_variacao_compra ?? "-"} />
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                            <DadoValorPrinter titulo="Pede Vr. Total NF" valor={produto.pede_valor_total_nf === "S" ? "Sim" : "Não"} />
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                            <DadoValorPrinter titulo="Emite Receita Agp" valor={produto.emite_receita === "S" ? "Sim" : "Não"} />
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                            <DadoValorPrinter titulo="Gera LMC" valor={produto.gera_lmc === "S" ? "Sim" : "Não"} />
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                            <DadoValorPrinter titulo="Grupo ANP" valor={produto.grupo_anp?.nome ?? "-"} />
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                            <DadoValorPrinter titulo="Registro Ministério da Agricultura" valor={produto.registro_agricola?.marca_comercial ?? "-"} />
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                            <DadoValorPrinter titulo="Classif. Origem" valor={getOrigem(produto.classificacao)} />
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                            <DadoValorPrinter titulo="Pede p/comprar" valor={produto.pode_comprar === "S" ? "Sim" : "Não"} />
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                            <DadoValorPrinter titulo="Desativado" valor={produto.desativado === "S" ? "Sim" : "Não"} />
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                            <DadoValorPrinter titulo="Produto Fórmula" valor={produto.produto_formula === "S" ? "Sim" : "Não"} />
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                            <DadoValorPrinter titulo="Ressupre" valor={produto.transfere === "S" ? "Sim" : "Não"} />
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                            <DadoValorPrinter titulo="Código Anterior" valor={produto.codigo_anterior ?? "-"} />
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                            <DadoValorPrinter titulo="Tipo Item" valor={produto.tipo_item ?? "-"} />
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                            <DadoValorPrinter titulo="Família" valor={produto.familia ?? "-"} />
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                            <DadoValorPrinter titulo="Tipo Produto" valor={produto.tipo_produto_codigo ?? "-"} />
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                            <DadoValorPrinter titulo="Loja Centro Distribu." valor={produto.codigo_cd?.nome ?? "-"} />
                        </Grid>
                    </Grid>
                    <Stack direction="row" spacing={2} mt={2} justifyContent="flex-end">
                        <Button
                            size="small"
                            variant="outlined"
                            color="primary"
                            startIcon={<EditIcon />}
                            onClick={() => setOpenEdit(true)}
                        >
                            Editar
                        </Button>
                    </Stack>
                </Box>
            </CardContent>
            <DialogEditDadosAdicionais
                open={openEdit}
                onClose={() => setOpenEdit(false)}
                produto={produto}
            />
        </Card>
    );
}

function getOrigem(codigo: string | undefined) {
    if (!codigo) return "-";
    return origem[codigo as keyof typeof origem] ?? "-";
}

const origem = {
    G: "Genuino",
    O: "Original",
    P: "Paralelo",
    U: "Outros"
}